export default __webpack_public_path__ + "7815a4b9e8f349dd20fc8f409d5010df.svg";